import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var MessageIcon = createIcon({
  displayName: 'MessageIcon',
  path: /*#__PURE__*/React.createElement("path", {
    d: "M2 4v10a2 2 0 002 2h8v6l6-6h2a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2z",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })
});
//# sourceMappingURL=Message.js.map